import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';

/**
 * VA-approved AI disclaimer text shown on every RAG (LLM) generated response.
 *
 * The phone number renders as a `va-telephone` link, so the copy is split
 * around it. `AI_DISCLAIMER_TEXT` keeps the flattened string for screen
 * readers, which need plain text rather than a link.
 */
export const AI_DISCLAIMER_TEXT_BEFORE_PHONE =
  'This answer is AI-generated and may contain inaccuracies. Verify important information or call MyVA411 main information line: ';

export const AI_DISCLAIMER_TEXT_AFTER_PHONE = ' (24/7).';

/**
 * Formats a contact the way `va-telephone` displays it, so the spoken text
 * can't drift from the link on screen: strip everything but digits, then dash
 * group only a 10 digit number. Anything else stays bare digits, which is
 * exactly what the component renders for it.
 *
 * @param {string} contact
 * @returns {string}
 */
export const formatDisclaimerPhone = contact =>
  `${contact}`
    .replace(/\D/g, '')
    .replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');

export const AI_DISCLAIMER_TEXT = `${AI_DISCLAIMER_TEXT_BEFORE_PHONE}${formatDisclaimerPhone(
  CONTACTS.VA_411,
)}${AI_DISCLAIMER_TEXT_AFTER_PHONE}`;
